module.exports = __webpack_public_path__ + "static/media/story_3.e9613e77.png";